




















































import {Component, Prop, Vue, Watch, Ref} from 'vue-property-decorator';
import {AccidentsGroup} from "@/read-model/AccidentsGroup";
import AccidentDetails from "@/components/AccidentDetails.vue";
import {Accident} from "@/read-model/accident";

@Component({
  components: {AccidentDetails}
})
export default class AccidentsGroupDetails extends Vue {
  @Ref() readonly accidentGroupDetails!: HTMLDivElement

  @Prop({required: true}) group: AccidentsGroup | undefined
  private selectedAccident: Accident | null = null
  visible = false

  mounted() {
    this.visible = true;
    this.$nextTick(() => {
      const size = {width: this.accidentGroupDetails.clientWidth, height: this.accidentGroupDetails.clientHeight};
      this.$emit('resized', size)
    })
  }

  @Watch('group')
  onGroupChanged() {
    this.selectedAccident = null
  }
}
